import {CustomCatalogueEntryUsageResponseBody} from '@dms/api/sales';

export type CustomCatalogueModel = {
  modelFamily: string;
  isCustomModelFamily: boolean;
  vehicleCount: number;
};

export type CustomCatalogueMakeGroup = {
  vehicleType: string;
  make: string;
  isCustomMake: boolean;
  totalVehicleCount: number;
  models: CustomCatalogueModel[];
};

type MakeGroupIdentity = Pick<CustomCatalogueMakeGroup, 'vehicleType' | 'make'>;

/** Identifies a make group across a refetch - also the progress key of a replacement. */
export const getMakeGroupKey = (group: MakeGroupIdentity) => `${group.vehicleType}|${group.make}`;

/** Only a custom model family has anything to remap under an official make. */
export const getCustomModels = (group: CustomCatalogueMakeGroup) =>
  group.models.filter((model) => model.isCustomModelFamily);

/**
 * The usage endpoint returns one row per model family, but replacing a make needs the whole make at
 * once: the backend requires a target for every model family used under it.
 */
export function groupUsageByMake(
  usage: CustomCatalogueEntryUsageResponseBody[]
): CustomCatalogueMakeGroup[] {
  const groups = new Map<string, CustomCatalogueMakeGroup>();

  usage.forEach((row) => {
    const key = getMakeGroupKey(row);
    const group = groups.get(key) ?? {
      vehicleType: row.vehicleType,
      make: row.make,
      isCustomMake: row.isCustomMake,
      totalVehicleCount: 0,
      models: [],
    };

    group.totalVehicleCount += row.vehicleCount;
    group.models.push({
      modelFamily: row.modelFamily,
      isCustomModelFamily: row.isCustomModelFamily,
      vehicleCount: row.vehicleCount,
    });

    groups.set(key, group);
  });

  return Array.from(groups.values());
}
